<template>
  <div>
    <AddCareer update />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import AddCareer from '../../../components/skillup/careers/AddCareer.vue'
export default {
  page: {
    title: 'ویرایش شغل',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-edit-careers',
  components: {
    AddCareer,
  },
}
</script>
